import { doPhoneRing, doSmsSound, doWaitImageByTime } from './../helpers/helpers';
import { Phone } from "../../src/components/phoneUI/PhoneClass";
import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { customer } from "../characters/Customer";
import { emily } from "../characters/Emily";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { stranger } from "../characters/Stranger";
import { strangerFemale } from "../characters/StrangerFemale";
import { vanessa } from "../characters/Vanessa";
import { doTransition } from "../helpers/helpers";
import { extras, images } from "./images";
import { V7VanessaCoffeeNightAfter } from "./V7";

export const V7VanessaCoffeeNight = async (): Promise<any> => {
    if (Question.globalAnswers.v7VanessaGiveCustomerWhatHeWants) {
        return jump(V7VanessaCoffeeNight_PhoneCall, "V7VanessaCoffeeNight_PhoneCall");
    }
    doTransition(images.v7.V7VanessaCoffeeNight_1);
    mc.think(`They are already here.`);

    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_2, { duration: 1 });
    customer.talk(`The coffee was cold.`);
    vanessa.talk(`What the fu... Hell are you talking about?`);
    vanessa.talk(`I gave it to you right away!`);
    customer.talk(`You need to do a better job.`);
    vanessa.talk(`If it was bad, why did you drink it all?`);
    customer.talk(`Because I'm a nice and considerable person.`);
    vanessa.talk(`Why don't you take this cup, and shove it...`);
    mc.talk(`Ahem.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_7);
    mc.talk(`Hey.`);
    vanessa.talk(`Took you long enough.`);
    customer.talk(`Welcome.`);
    customer.talk(`Why don't you join me?`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_8);
    customer.talk(`Can my lovely waitress get you anything?`);
    mc.talk(`No, I'm good.`);
    customer.talk(`Fine by me.`);
    // ImageClass.setImage(images.v7.V7VanessaCoffeeNight_9);
    // TODO: add joke about ordering tons of stuff+ Vanessa angry expression
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_2);
    customer.talk(`I'll have another coffee asap.`);
    vanessa.talk(`It's going to be your third cup!`);
    vanessa.talk(`I've always thought old men need to pee every five minutes regardless.`);
    customer.talk(`Watch it.`);
    vanessa.talk(`Sorry!`);
    vanessa.talk(`I'll just take your cup.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_3);
    customer.talk(`This cup?`);
    customer.talk(`Sure, you can take it...`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_4);
    customer.talk(`From over there.`);
    customer.talk(`And don't go behind my chair, I hate getting shoved.`);
    vanessa.talk(`Nice.`);
    vanessa.talk(`Do you want to put it further away?`);
    customer.talk(`That's far enough for you to reach.`);

    customer.talk(`I'm waiting for my order.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_5);
    vanessa.talk(`Ah...`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_6);
    if (Question.globalAnswers.v7VanessaGiveCustomerWhatHeWants) {
        mc.think(`Vanessa wasn't wrong about him wanting something sexual...`);
        mc.think(`He makes it so obvious...`);
    } else {
        mc.think(`This guy...`);
    }
    mc.think(`That ass though...`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_11, { duration: 1 });
    customer.talk(`So here we are.`);
    customer.talk(`For the second time.`);

    if (Question.globalAnswers.v7VanessaGiveCustomerWhatHeWants) {

    } else {
        mc.think(`This is a perfect chance to know more about him.`);
    }
    mc.think(`But we are not on the best of terms.`);



    mc.talk(`Hey Mr...?`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_14);
    customer.talk(`You can address me as Sir.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_11);
    mc.talk(`Obviously Mr. Sir.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_14);
    customer.talk(`Just Sir.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_11);
    mc.talk(`Yes, of course.`);
    if (mc.properties.v3RudeToTheCustomer) {
        mc.talk(`Sir, I know we started on the wrong foot, but you don't have to punish Vanessa for it.`);
    } else {
        mc.talk(`Sir, I know Vanessa did something inappropriate, but I think this is going too far...`);
    }

    mc.talk(`She is a good girl.`);
    mc.think(`Yeah, right.`);
    if (mc.properties.v3RudeToTheCustomer) {
        mc.talk(`And she hasn't done anything wrong. It was my fault, why are you trying to make her life miserable?`);
        ImageClass.setImage(images.v7.V7VanessaCoffeeNight_14);
        customer.talk(`You really showed up as a changed man today, didn't you?`);
        ImageClass.setImage(images.v7.V7VanessaCoffeeNight_11);
        mc.talk(`It's like I've always been.\nYou just caught me up in a bad mood the other day, it wasn't appropriate and I apologize.`);

    } else {
        mc.talk(`But she just made a mistake.`);
        mc.talk(`It's not like her at all, she would've taken it all back if she could`);
    }
    customer.talk(`...`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_11);
    mc.talk(`You seem like a well-respected man, Vanessa is just a stupid, young adult.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_10);
    mc.talk(`You are better than that.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_11);
    mc.talk(`The other day you got a call...\nIt seemed important...`);
    mc.talk(`Was it your wife?`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_14);
    customer.talk(`My wife is dead.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_11);
    mc.talk(`I'm sorry to hear that.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_14);
    customer.talk(`She was an old hog, I'm better off anyway.`);
    mc.think(`Wow...`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_11);
    mc.talk(`Your daughter maybe?`);
    mc.talk(`No... It's not it...`);
    mc.talk(`It must be your grand-daughter?`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_12);
    mc.talk(`Yes it was...`);
    mc.talk(`You must care for her a lot.`);
    customer.talk(`Yes... I love her dearly.`);
    mc.talk(`And I bet she loves you too.`);
    customer.talk(`I'd like to think so.`);
    mc.talk(`I bet she does.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_13);
    customer.talk(`I do everything for her. But lately she is too busy to spend some time with me.`);
    customer.talk(`She just calls me when she needs something.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_12);
    mc.talk(`That's how children are.`);
    mc.talk(`I should know! I bet I'm about her age.`);
    customer.talk(`More or less.`);
    mc.talk(`Where does she think you are right now?`);
    customer.talk(`...`);
    mc.talk(`She doesn't know...`);

    mc.talk(`You didn't tell her because it's not like you.`);
    if (mc.properties.v3RudeToTheCustomer) {
        mc.talk(`You were just caught up in the moment. Just like Vanessa was.`);

    } else {
        mc.talk(`You were just caught up in the moment. Just like I was.`);

    }
    if (mc.properties.v3RudeToTheCustomer) {
        mc.talk(`I want to apologize on behalf of Vanessa again.`);
        mc.talk(`Why don't you just give her the job back and we can call it a day?`);

    } else {
        mc.talk(`I've already apologize, just talk to the owner and give Vanessa her job back and we can call it a day?`);

    }

    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_12);
    mc.talk(`We can easily leave it all behind us.`);

    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_16, { duration: 1 });
    vanessa.talk(`Here is your coffee.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_17);
    customer.talk(`You can drink it.`);
    vanessa.talk(`What?`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_18, { duration: 1 });
    vanessa.talk(`WAIT!\nWHERE ARE YOU GOING?`, { method: "Shouting" });
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_19);
    vanessa.talk(`DOES THAT MEAN I GOT MY JOB BACK?`, { method: "Shouting" });
    vanessa.talk(`GRANDPA???`, { method: "Shouting" });
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_20);
    vanessa.talk(`SO YOU DON'T WANT A HANDJOB???`, { method: "Shouting" });
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_21);
    empty.think(`*Smack*`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_22);
    stranger.talk(`What???`);


    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_23, { duration: 1 });
    vanessa.talk(`What the fuck ${mc.name}!`);
    vanessa.talk(`He just left!`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_24);
    mc.talk(`Don't you see this as a good thing?`);
    mc.talk(`He obviously came here to get something else.`);

    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_23);
    vanessa.talk(`Well, I could've given it to him and be done with this!`);
    vanessa.talk(`I knew talking to him was a bad idea.`);
    mc.talk(`Didn't you say it was your idea?`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_25);
    vanessa.talk(`It would've been if it was working.\nNow it's your BAD idea.`);
    mc.talk(`Whatever...`);
    vanessa.talk(`I only heard parts of the conversation.\nDid you find anything we can use as a leverage over him?`);
    mc.talk(`I only know he has a grand-daughter he cares about.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_26);
    vanessa.talk(`PERFECT!`);
    vanessa.talk(`You'll fuck her! I'll take photos! And we'll threaten him to post them online if he doesn't give me my job back!`);
    if (mc.properties.vanessaStatus === "blackmailAttempt" || mc.properties.vanessaStatus === "blackmail") {
        mc.talk(`Hold your horses... Blackmail got us into this mess in the first place.`);
    } else {
        mc.talk(`That's blackmail... Are you sure you want to go down this route?`);
        ImageClass.setImage(images.v7.V7VanessaCoffeeNight_23);
        vanessa.talk(`Why not?! It's perfect.`);
    }
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_25);
    mc.talk(`Let's just try to find her first before we do something extreme.`);
    vanessa.talk(`For the record, I think this idea sucks!`);
    mc.talk(`Do you have a better idea?`);
    vanessa.talk(`It depends.`);
    mc.talk(`On what?`);
    vanessa.talk(`Are you hungry?`);



    return jump(V7VanessaCoffeeNightAfter, "V7VanessaCoffeeNightAfter");
};

export const V7VanessaCoffeeNight_PhoneCall = async (): Promise<any> => {
    if (Game.seenScenarios.includes(`V7_JennyJoeRivalBarBefore`)) {
        mc.think(`Vanessa still needs to meet with that grandpa, I wonder if she'll make it now.`);
        doTransition(images.v7.V7RoomNight, null, 1.5);

    } else {
        doWaitImageByTime(images.v7.V7RoomNight, null, 1.5);

    }
    doSmsSound();
    mc.think(`It's Vanessa.`);


    await Phone.showMessagesUI({ name: vanessa.name, profileImage: extras.VanessaProfilePic2 }, async () => {
        Phone.setImage({ ...images.v7.V7VanessaCoffeeNightSelfie, character: vanessa.character, options: { wait: false } });
        Phone.setMessage({ character: mc.character, text: `I guess things didn't go as planned?` });
        Phone.setMessage({ character: vanessa.character, text: `To say the least! The old man is weird as fuck!` });
        Phone.setMessage({ character: mc.character, text: `What happened? Tell me.` });
        Phone.setMessage({ character: vanessa.character, text: `Calling.` });
        Phone.closeMessagesUI();
    });
    doPhoneRing();

    ImageClass.setImage(images.v7.V7RoomNightOnPhone);
    vanessa.talk(`Holy shit!`, { method: "Over Phone" });
    mc.talk(`Tell me what happened! I'm curious!`, { method: "On Phone" });
    vanessa.talk(`Alright.`, { method: "Over Phone" });
    vanessa.talk(`So I got dressed and went to the coffee shop...`, { method: "Over Phone" });
    return jump(V7VanessaCoffeeNight_VanessaAlone, "V7VanessaCoffeeNight_VanessaAlone");
};

export const V7VanessaCoffeeNight_VanessaAlone = async (): Promise<any> => {
    // ImageClass.setImage(images.v7.V7VanessaCoffeeNight_27, { duration: 1.5, wait: 1.5, hideText: true });
    doWaitImageByTime(images.v7.V7VanessaCoffeeNight_27, null, 2);

    vanessa.think(`Grandpa is here...`);
    vanessa.think(`Time to put up a show.`);
    ImageClass.setImage({ ...images.v7.V7VanessaCoffeeNight_28, partialsToDisplay: [images.v7.V7VanessaCoffeeNight_28.partials.V7VanessaCoffeeNight_28_p] });
    customer.talk(`You are late.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28);
    vanessa.talk(`You are early.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28.partials.V7VanessaCoffeeNight_28_p);
    customer.talk(`Where is your friend?`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28);
    vanessa.talk(`I'm a big girl, I can manage on my own.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28.partials.V7VanessaCoffeeNight_28_p);
    customer.talk(`So I see.`);
    customer.talk(`The dress looks incredible on you.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28);
    vanessa.talk(`I know! I get to keep it, right?`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28.partials.V7VanessaCoffeeNight_28_p);
    customer.talk(`Of course. It's a gift from me to you.`);

    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28);
    vanessa.talk(`Great!`);

    vanessa.talk(`So... What are we doing here?`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28.partials.V7VanessaCoffeeNight_28_p);
    customer.talk(`Jumping right to business.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28);
    vanessa.talk(`It's not like we have things in common... You are like... Two hundred years old.`);
    customer.talk(`...`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28.partials.V7VanessaCoffeeNight_28_p);
    customer.talk(`I summoned you here, to get the service I've never gotten.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28);
    vanessa.talk(`That's it? Easy.`);
    vanessa.talk(`Why the dress though?`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28.partials.V7VanessaCoffeeNight_28_p);
    customer.talk(`So you'd look your best while you serve me.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28);
    vanessa.talk(`It's not far off from what I usually wear so fuck it, who cares.`);

    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28.partials.V7VanessaCoffeeNight_28_p);
    customer.talk(`Ok, you can start at any time.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28);
    vanessa.talk(`Start?`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28.partials.V7VanessaCoffeeNight_28_p);
    customer.talk(`Yes, act like I'm a customer that just arrived and needs service.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28);
    vanessa.talk(`O...K...`);
    vanessa.talk(`Ahem...`);
    vanessa.talk(`Welcome! How may I help you?`);

    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28.partials.V7VanessaCoffeeNight_28_p);
    customer.talk(`What a lovely barista!`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28);
    vanessa.talk(`...`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28.partials.V7VanessaCoffeeNight_28_p);
    customer.talk(`I would like a cup of coffee please.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28);
    vanessa.talk(`How'd you like it made?`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28.partials.V7VanessaCoffeeNight_28_p);
    customer.talk(`Surprise me.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_28);
    vanessa.talk(`Coming right out!`);
    doTransition(images.v7.V7VanessaCoffeeNight_30);
    vanessa.talk(`There you go sir.`);
    customer.talk(`Why thank you!`);
    customer.talk(`I wasn't wrong. You are very lovely.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_31);
    vanessa.talk(`Glad to be of service!`);

    customer.talk(`That is a good looking dress you got there.`);
    customer.talk(`Is that the dress code around here?`);
    vanessa.think(`Someone is into role playing...`);
    vanessa.talk(`No. It's just a present I got from a very special person.`);
    customer.talk(`I bet.`);
    customer.talk(`Why don't you get a little closer to me so I can have a better look?`);
    vanessa.talk(`Of course!`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_33);
    vanessa.talk(`Is that better?`);
    customer.talk(`It is.`);
    customer.talk(`This dress is extremely short.`);
    vanessa.talk(`Yup, just the way I like it.`);
    customer.talk(`That makes me wonder... Did that guy get you matching lingerie?`);
    vanessa.talk(`Why don't you check?`);
    customer.talk(`May I?`);
    vanessa.talk(`Of course! You are my favorite customer!`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_34);
    customer.talk(`Let's see.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_35, { duration: 1 });
    customer.talk(`I guess he didn't.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_36);
    vanessa.talk(`Nope.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_37);
    vanessa.talk(`You know what else he didn't get for me?`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_38);
    customer.talk(`What?`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_39, { duration: 1 });
    vanessa.talk(`A bra.`);
    vanessa.talk(`Do you like what you see?`);
    customer.talk(`You have amazing breasts.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_40);
    vanessa.talk(`I see you are starting to get excited.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_41);
    vanessa.talk(`Go ahead.`);
    vanessa.talk(`You can touch, don't be shy.`);
    customer.talk(`What are you doing?!`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_42);
    customer.talk(`Don't touch me!`);
    vanessa.talk(`What?!`);
    customer.talk(`I didn't tell you to show your breasts and certainly not to touch me.`);
    vanessa.talk(`What the fuck? But you said you liked them!`);
    customer.talk(`Next time you should follow instructions.`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_43, { duration: 1 });
    vanessa.talk(`I did everything you asked!`, { method: `Shouting` });
    vanessa.talk(`Just let me blow you already so we can get it over with!`, { method: `Shouting` });
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_44);
    strangerFemale.talk(`So for dinner I was thinking about spaghetti bolognese and maybe a small salad on the side...`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_45);
    strangerFemale.think(`*Smack*`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_46);
    stranger.talk(`What?`);
    ImageClass.setImage(images.v7.V7VanessaCoffeeNight_47);
    vanessa.think(`I wonder if I got my job back...`);
    return jump(V7VanessaCoffeeNight_PhoneCallAfter, "V7VanessaCoffeeNight_PhoneCallAfter");
};
export const V7VanessaCoffeeNight_PhoneCallAfter = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7RoomNightOnPhone, { duration: 1.5, wait: 1.5, hideText: true });
    vanessa.talk(`Do you understand now?`, { method: "Over Phone" });
    mc.talk(`I do.`, { method: "On Phone" });
    vanessa.talk(`Like what the fuck?!`, { method: "Over Phone" });
    vanessa.talk(`I was ready to give him a quick one and be done with it...`, { method: "Over Phone" });
    vanessa.talk(`I guess he just wanted to torture me.`, { method: "Over Phone" });

    mc.talk(`I still think he wants something sexual out of you.`, { method: "On Phone" });
    mc.talk(`But I guess he likes to be in control.`, { method: "On Phone" });
    vanessa.talk(`He was! I did everything he said.`, { method: "Over Phone" });
    mc.talk(`You pushed it too hard.`, { method: "On Phone" });
    mc.talk(`Next time just don't improvise.`, { method: "On Phone" });
    vanessa.talk(`Do you really think there is going to be a next time?`, { method: "Over Phone" });
    mc.talk(`He is too invested in this to give up.`, { method: "On Phone" });
    mc.talk(`Unless you decide you don't want your job back anymore.`, { method: "On Phone" });
    vanessa.talk(`What? No way.`, { method: "Over Phone" });
    mc.talk(`So I guess he'll contact you soon.`, { method: "On Phone" });
    vanessa.talk(`We'll see.`, { method: "Over Phone" });
    vanessa.talk(`I'm going to sleep! Bye!`, { method: "Over Phone" });

    return jump(V7VanessaCoffeeNightAfter, "V7VanessaCoffeeNightAfter");
};